import { render, staticRenderFns } from "./WhyJoinACPSchemeBox.vue?vue&type=template&id=588afbca&"
import script from "./WhyJoinACPSchemeBox.vue?vue&type=script&lang=js&"
export * from "./WhyJoinACPSchemeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports